import { createRoutine } from '@skunexus/utils';

const prefix = 'PURCHASE_ORDER_OVERVIEW_MODULE/RESOLVE';

export const cancelPO = createRoutine(`${prefix}/CANCEL_PO`);
export const cancelItems = createRoutine(`${prefix}/CANCEL_ITEMS`);
